import Immutable from 'immutable';
import Post from '../models/post';
import Profile from '../models/profile';
import Image from '../models/image';
import Comment from '../models/comment';
import Link from '../models/link';
import Video from '../models/video';
import Card from '../models/card';
import CouponCard from '../models/couponCard';
import Coupon from '../models/coupon';

export default (serialized) => 
  Immutable.fromJS(serialized)
    .update('profile', Immutable.Map(),
      profile => profile.updateIn(['posts', 'items'], items => Immutable.OrderedSet(items))
    ).update('entities', entities => {
      if (!entities) {
        return;
      }
      return entities.update('profiles', Immutable.Map(), profiles => {
        return profiles.map((value) => {
          return new Profile(value.update('call2action', (call2action) => Immutable.fromJS(call2action))
            .update('consult', consult => Immutable.fromJS(consult))
          )
        })
      }).update('comments', Immutable.Map(), comments => {
        return comments.map((value) => {
          return new Comment(value)
        })
      }).update('posts', Immutable.Map(), posts => {
        return posts.map((value) => {
          return new Post(value)
        })
      }).update('cards', Immutable.Map(), cards => {
        return cards.map((value) => {
          return new Card(
            value
            .update('button', (button) => Immutable.fromJS(button))
            .update('contents', (contents) => Immutable.fromJS(contents))
          )
        })
      }).update('verticalCards', Immutable.Map(), cards => {
        return cards.map((value) => {
          return new Card(
            value
            .update('button', (button) => Immutable.fromJS(button))
            .update('contents', (contents) => Immutable.fromJS(contents))
          )
        })
      }).update('couponCards', Immutable.Map(), couponCards => {
        return couponCards.map((value) => {
          return new CouponCard(value)
        })
      }).update('images', Immutable.Map(), images => {
        return images.map((value) => {
          return new Image(value)
        })
      }).update('links', Immutable.Map(), links => {
        return links.map((value) => {
          return new Link(value.update(
            'images', (images) => images.map(image => new Image(image))
          ))
        })
      }).update('videos', Immutable.Map(), videos => {
        return videos.map((value) => {
          return new Video(value)
        })
      }).update('coupons', Immutable.Map(), coupons => {
        return coupons.map((value) => {
          return new Coupon(value)
        })
      });
    });




// WEBPACK FOOTER //
// ./src/utils/deserialize.js